import { render, staticRenderFns } from "./DayNews.vue?vue&type=template&id=cb211524&"
import script from "./DayNews.vue?vue&type=script&lang=js&"
export * from "./DayNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb211524')) {
      api.createRecord('cb211524', component.options)
    } else {
      api.reload('cb211524', component.options)
    }
    module.hot.accept("./DayNews.vue?vue&type=template&id=cb211524&", function () {
      api.rerender('cb211524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/day-news/DayNews.vue"
export default component.exports